export default "__VITE_ASSET__C7DVuNuq__"